import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import type { Task, TaskStatus } from '@ilteducation/article-publisher-types';
import config from '../../config/ConfigProvider';
import axios from 'axios';
import { GetTasksResponse } from '@ilteducation/article-publisher-types';
import type { Job } from '@ilteducation/studio-jobs-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlePublisherTaskDataTable',
  setup(__props, { expose }) {

const isStaging = computed(() => process.env.VUE_APP_ENVIRONMENT === 'staging');
const allStatuses: TaskStatus[] = ['created', 'studio-recording', 'completed'];

const search = ref<string>('');

const selectedStatus = ref<string[]>([]);

const filteredTasks = computed(() =>
  !selectedStatus.value.length ? tasks.value : tasks.value.filter((t) => selectedStatus.value.includes(t.status)),
);
const tasks = ref<Task[]>([]);
const isLoadingTasks = ref(false);
const studioJobs = ref<Record<string, Job>>({});

const taskTableHeaders = [
  { text: 'ID', value: 'id' },
  { text: 'Name', value: 'name' },
  { text: 'Status', value: 'status' },
  { text: 'Language', value: 'language' },
  { text: 'Content Id', value: 'contentId' },
  { text: 'Created', value: 'createdAt' },
  { text: 'Updated', value: 'updatedAt' },
];

const getArticleTasks = async () => {
  try {
    isLoadingTasks.value = true;
    const response = await axios.get<GetTasksResponse>(`${config.value('theArticlePublisherUrl')}/articles`);
    tasks.value = response.data.data;
    for (const task of tasks.value) {
      try {
        if (task.studioJobId) {
          const jobResp = await axios.get<Job>(`${config.value('studioJobsUrl')}/jobs/${task.studioJobId}`);
          studioJobs.value[task.studioJobId!] = jobResp.data;
        }
      } catch (error) {
        if ((error as any).status !== 404) {
          console.error(`Error fetching data for task ${task.id}:`, error);
        }
      }
    }
  } finally {
    isLoadingTasks.value = false;
  }
};

onMounted(() => {
  getArticleTasks();
});

expose({
  refresh: getArticleTasks,
});

return { __sfc: true,isStaging, allStatuses, search, selectedStatus, filteredTasks, tasks, isLoadingTasks, studioJobs, taskTableHeaders, getArticleTasks }
}

})